/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ brands: NonNullable<unknown> }} Account_Notifications_Brands_LabelInputs */

const he_account_notifications_brands_label = /** @type {(inputs: Account_Notifications_Brands_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`מותגים: ${i?.brands}`)
};

const en_account_notifications_brands_label = /** @type {(inputs: Account_Notifications_Brands_LabelInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Brands: ${i?.brands}`)
};

/**
* | output |
* | --- |
* | "Brands: {brands}" |
*
* @param {Account_Notifications_Brands_LabelInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const account_notifications_brands_label = /** @type {((inputs: Account_Notifications_Brands_LabelInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Account_Notifications_Brands_LabelInputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_account_notifications_brands_label(inputs)
	return en_account_notifications_brands_label(inputs)
});